namespace TabAurous.OMS {
    export interface ProductSizeMasterRow {
        ProductSizeId?: number;
        CategoryId?: number;
        CategoryName?: string;
        ProductSizeCode?: string;
        SizeType?: string;
        MM?: number;
        CM?: number;
        INCH?: number;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        Sys_Date?: string;
    }

    export namespace ProductSizeMasterRow {
        export const idProperty = 'ProductSizeId';
        export const nameProperty = 'ProductSizeCode';
        export const localTextPrefix = 'OMS.ProductSizeMaster';
        export const lookupKey = 'OMS.ProductSizeMaster';

        export function getLookup(): Q.Lookup<ProductSizeMasterRow> {
            return Q.getLookup<ProductSizeMasterRow>('OMS.ProductSizeMaster');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            ProductSizeId = "ProductSizeId",
            CategoryId = "CategoryId",
            CategoryName = "CategoryName",
            ProductSizeCode = "ProductSizeCode",
            SizeType = "SizeType",
            MM = "MM",
            CM = "CM",
            INCH = "INCH",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            Sys_Date = "Sys_Date"
        }
    }
}
